import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, className = "", y = 46 }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y, scale: 0.965 }}
    whileInView={{ opacity: 1, y: 0, scale: 1 }}
    viewport={{ once: true, margin: "-70px" }}
    transition={{ type: "spring", stiffness: 110, damping: 15, delay }}
  >
    {children}
  </motion.div>
);
